import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { ref: "wrapper" };
const _hoisted_2 = ["onSubmit"];
const _hoisted_3 = ["innerHTML"];
import { ref, computed, nextTick } from 'vue';
import { ValidationProvider, ValidationField } from 'vue-validate-form';
import PhoneInput from '@/components/phone-input/phone-input.vue';
import ValidationErrors from '@/components/ui/validation-errors.vue';
import { getLocalStorageItem } from '@/utils/local-storage';
import { trlMessage } from '@/services/i18n';
import { UiButton, UiCheckbox, UiError, UiStack } from '@huntflow/ui';
import { useWindowSize } from '@vueuse/core';
export default /*@__PURE__*/ _defineComponent({
    __name: 'phone-number',
    props: {
        loading: { type: Boolean, default: false },
        retryCount: { default: 0 },
        errorMessage: { default: '' }
    },
    emits: ["submit", "change"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const phone = ref({
            number: getLocalStorageItem('phone') || ''
        });
        const policyField = ref(null);
        const acceptPolicy = ref(!!getLocalStorageItem('phone'));
        const policyError = ref(false);
        const selectedCode = ref(getLocalStorageItem('phonecode') || '+7');
        const retryTimerText = computed(() => trlMessage('login.phone.retry.timer', { count: formatTimer(__props.retryCount) }));
        const { width } = useWindowSize();
        const buttonSize = computed(() => (width.value < 756 ? 'xl' : 'xxl'));
        const checkboxLabel = computed(() => trlMessage('accept.policy', { url: 'https://huntflow.ru/docs/privacy-policy' }));
        function resolver(values) {
            return {
                values,
                errors: values.number ? {} : { number: [{ message: trlMessage('error.required') }] }
            };
        }
        function onSubmit(values) {
            if (!acceptPolicy.value) {
                policyError.value = true;
                focusPolicy();
                return;
            }
            if (__props.loading || __props.retryCount > 0) {
                return;
            }
            emit('submit', {
                number: values.number,
                countryCode: selectedCode.value
            });
        }
        function onPolicyChange(checked) {
            if (checked) {
                policyError.value = false;
            }
        }
        function focusPolicy() {
            nextTick(() => policyField.value?.querySelector('[role="checkbox"]')?.focus());
        }
        function setCode(code) {
            selectedCode.value = code;
            emit('change');
        }
        function formatPhoneNumber(value) {
            return value?.replace(/\D/g, '') || '';
        }
        function formatTimer(seconds) {
            const minutes = Math.floor(seconds / 60);
            const remainder = seconds % 60;
            return `${minutes}:${remainder.toString().padStart(2, '0')}`;
        }
        function onChangeInput(onChange, value) {
            emit('change');
            onChange(formatPhoneNumber(value));
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(ValidationProvider), {
                    "default-values": phone.value,
                    resolver: resolver,
                    onSubmit: onSubmit
                }, {
                    default: _withCtx(({ handleSubmit }) => [
                        _createElementVNode("form", {
                            method: "post",
                            onSubmit: _withModifiers(handleSubmit, ["prevent"])
                        }, [
                            _createVNode(_unref(ValidationField), { name: "number" }, {
                                default: _withCtx(({ modelValue, onChange, name, invalid }) => [
                                    _createVNode(_unref(UiStack), {
                                        gap: "s",
                                        size: "full",
                                        direction: "column"
                                    }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("label", {
                                                for: "number",
                                                class: _normalizeClass(_ctx.$style.label)
                                            }, _toDisplayString(_unref(trlMessage)('login.number')), 3),
                                            _createVNode(PhoneInput, {
                                                id: "number",
                                                "has-error": invalid || !!__props.errorMessage,
                                                value: modelValue,
                                                name: name,
                                                disabled: __props.loading,
                                                onSetCode: setCode,
                                                onInput: ($event) => (onChangeInput(onChange, $event))
                                            }, null, 8, ["has-error", "value", "name", "disabled", "onInput"]),
                                            invalid
                                                ? (_openBlock(), _createBlock(ValidationErrors, {
                                                    key: 0,
                                                    name: "number"
                                                }))
                                                : (__props.errorMessage)
                                                    ? (_openBlock(), _createBlock(_unref(UiError), { key: 1 }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(__props.errorMessage), 1)
                                                        ]),
                                                        _: 1
                                                    }))
                                                    : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                    }, 1024)
                                ]),
                                _: 1
                            }),
                            _createElementVNode("div", {
                                ref_key: "policyField",
                                ref: policyField,
                                class: _normalizeClass([_ctx.$style.checkboxWrapper, policyError.value && _ctx.$style.checkboxWrapperError])
                            }, [
                                _createVNode(_unref(UiCheckbox), {
                                    modelValue: acceptPolicy.value,
                                    "onUpdate:modelValue": [
                                        _cache[0] || (_cache[0] = ($event) => ((acceptPolicy).value = $event)),
                                        onPolicyChange
                                    ],
                                    class: _normalizeClass(_ctx.$style.checkbox),
                                    disabled: __props.loading
                                }, {
                                    label: _withCtx(() => [
                                        _createElementVNode("span", { innerHTML: checkboxLabel.value }, null, 8, _hoisted_3)
                                    ]),
                                    _: 1
                                }, 8, ["modelValue", "class", "disabled"])
                            ], 2),
                            _createVNode(_unref(UiButton), {
                                size: buttonSize.value,
                                disabled: __props.retryCount > 0 || __props.loading,
                                "html-type": "submit",
                                fill: "",
                                loading: __props.loading
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(trlMessage)('button.code')), 1)
                                ]),
                                _: 1
                            }, 8, ["size", "disabled", "loading"]),
                            (__props.retryCount > 0)
                                ? (_openBlock(), _createElementBlock("p", {
                                    key: 0,
                                    class: _normalizeClass(_ctx.$style.retryTimer)
                                }, _toDisplayString(retryTimerText.value), 3))
                                : _createCommentVNode("", true)
                        ], 40, _hoisted_2)
                    ]),
                    _: 1
                }, 8, ["default-values"])
            ], 512));
        };
    }
});
